<div class="kr-popin-wrapper" :class="dynamicClasses" :style="dynamicStyles"><slot></slot></div>